import { useAuth } from "../../context/AuthContext";
import GridShape from "../../components/common/GridShape";
import PageMeta from "../../components/common/PageMeta";

/**
 * 접근 가능한 메뉴가 하나도 없는 계정에게 보여주는 안내 화면.
 * 빈 화면이나 무한 리다이렉트 대신, 무엇을 하면 되는지(권한 요청·다른 계정 로그인)를 알려준다.
 */
export default function NoAccess() {
  const { signOut } = useAuth();

  return (
    <>
      <PageMeta title="접근 가능한 메뉴가 없습니다" description="이 계정으로 볼 수 있는 메뉴가 없습니다." />
      <div className="relative flex flex-col items-center justify-center min-h-screen p-6 overflow-hidden z-1">
        <GridShape />

        <div className="mx-auto w-full max-w-[242px] text-center sm:max-w-[492px]">
          <h1 className="mb-6 font-bold text-gray-800 text-title-md dark:text-white/90 xl:text-title-2xl">
            볼 수 있는 메뉴가 없어요
          </h1>

          <p className="mt-4 mb-8 text-base text-gray-700 dark:text-gray-400 sm:text-lg">
            이 계정에는 아직 열람 권한이 없습니다.
            <br />
            관리자에게 권한을 요청하시거나, 다른 계정으로 로그인해 주세요.
          </p>

          <button
            onClick={signOut}
            className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-5 py-3.5 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200"
          >
            다른 계정으로 로그인
          </button>
        </div>
      </div>
    </>
  );
}
